"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The FeuerwehrNotification model module.
 * @module model/FeuerwehrNotification
 * @version 0.0.1
 */
class FeuerwehrNotification {
  /**
   * Constructs a new <code>FeuerwehrNotification</code>.
   * @alias module:model/FeuerwehrNotification
   * @param feuerwehrId {Number} 
   * @param nutzerId {String} 
   * @param id {Number} 
   * @param feuerwehrName {String} 
   */
  constructor(feuerwehrId, nutzerId, id, feuerwehrName) {
    FeuerwehrNotification.initialize(this, feuerwehrId, nutzerId, id, feuerwehrName);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, feuerwehrId, nutzerId, id, feuerwehrName) {
    obj['feuerwehr_id'] = feuerwehrId;
    obj['nutzer_id'] = nutzerId;
    obj['id'] = id;
    obj['feuerwehr_name'] = feuerwehrName;
  }

  /**
   * Constructs a <code>FeuerwehrNotification</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FeuerwehrNotification} obj Optional instance to populate.
   * @return {module:model/FeuerwehrNotification} The populated <code>FeuerwehrNotification</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FeuerwehrNotification();
      if (data.hasOwnProperty('feuerwehr_id')) {
        obj['feuerwehr_id'] = _ApiClient.default.convertToType(data['feuerwehr_id'], 'Number');
      }
      if (data.hasOwnProperty('nutzer_id')) {
        obj['nutzer_id'] = _ApiClient.default.convertToType(data['nutzer_id'], 'String');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('feuerwehr_name')) {
        obj['feuerwehr_name'] = _ApiClient.default.convertToType(data['feuerwehr_name'], 'String');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>FeuerwehrNotification</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FeuerwehrNotification</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of FeuerwehrNotification.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['nutzer_id'] && !(typeof data['nutzer_id'] === 'string' || data['nutzer_id'] instanceof String)) {
      throw new Error("Expected the field `nutzer_id` to be a primitive type in the JSON string but got " + data['nutzer_id']);
    }
    // ensure the json data is a string
    if (data['feuerwehr_name'] && !(typeof data['feuerwehr_name'] === 'string' || data['feuerwehr_name'] instanceof String)) {
      throw new Error("Expected the field `feuerwehr_name` to be a primitive type in the JSON string but got " + data['feuerwehr_name']);
    }
    return true;
  }
}
FeuerwehrNotification.RequiredProperties = ["feuerwehr_id", "nutzer_id", "id", "feuerwehr_name"];

/**
 * @member {Number} feuerwehr_id
 */
FeuerwehrNotification.prototype['feuerwehr_id'] = undefined;

/**
 * @member {String} nutzer_id
 */
FeuerwehrNotification.prototype['nutzer_id'] = undefined;

/**
 * @member {Number} id
 */
FeuerwehrNotification.prototype['id'] = undefined;

/**
 * @member {String} feuerwehr_name
 */
FeuerwehrNotification.prototype['feuerwehr_name'] = undefined;
var _default = exports.default = FeuerwehrNotification;